import { render, staticRenderFns } from "./ModalUserNew.vue?vue&type=template&id=73cecf81&"
import script from "./ModalUserNew.vue?vue&type=script&lang=js&"
export * from "./ModalUserNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports